import Vue from 'vue'
import Router from 'vue-router'
import PatientQueue from '../views/PatientQueue.vue'
import InsuranceVerification from '../views/InsuranceVerification.vue'
import Login from '../views/Login'
import VisitDetail from '../views/VisitDetail'
import Visits from '../views/Visits'
import store from './store'
import ResetPassword from '../views/ResetPassword'
import ForgotPassword from '../views/ForgotPassword'
import PatientEstimate from '../views/PatientEstimate'
import PatientDetail from '../views/PatientDetail'
import Estimates from '../views/Estimates'
import VirtualVisit from '../views/VirtualVisit'
import Analytics from '../views/Analytics'
import Bundles from '@/views/Bundles'
import BundlePaymentDistributions from '@/views/BundlePaymentDistributions'
import BundlePaymentDistribution from '@/views/BundlePaymentDistribution'
import Payees from '@/views/Payees'
import PayeeSignup from '@/views/PayeeSignup'
import PayeeDashboard from '@/views/PayeeDashboard'
import EmployerDashboard from '@/views/EmployerDashboard'
import Users from '@/views/Users'
import AuditLogs from '@/views/AuditLogs'
import UB04Claim from '@/views/UB04Claim'
import AllowableFeeSchedules from '@/views/AllowableFeeSchedules'
import AllowableFeeScheduleCodes from '@/views/AllowableFeeScheduleCodes'
import AscFeeSchedules from '@/views/AscFeeSchedules'
import AscFeeSchedulesCodes from '@/views/AscFeeScheduleCodes'
import EmployerEpisodeLibrary from '@/views/EmployerEpisodeLibrary'
import BundleCandidates from '@/views/BundleCandidates.vue'
import InsuranceBenefits from '@/views/InsuranceBenefits.vue'
import CustomNotifications from '@/views/CustomNotifications.vue'
import EstimateTemplates from '@/views/EstimateTemplates.vue'
import SearchPatient from '@/views/SearchPatient.vue'
import EstimateFees from '@/views/EstimateFees.vue'
import EstimateAscFees from '@/views/EstimateAscFees.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'patient-queue',
      component: PatientQueue
    },
    {
      path: '/insurance-verification',
      name: 'insurance-verification',
      component: InsuranceVerification
    },
    {
      path: '/visit/:id',
      name: 'visit',
      component: VisitDetail,
      props: true
    },
    {
      path: '/virtual-visit/:id',
      name: 'virtual-visit',
      component: VirtualVisit,
      props: true
    },
    {
      path: '/visits',
      name: 'visits',
      component: Visits,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: true
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
      props: (route) => ({ token: route.query.token })
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
      props: (route) => ({ email: route.query.email })
    },
    {
      path: '/payee-signup',
      name: 'payee-signup',
      component: PayeeSignup,
      props: (route) => ({
        email: route.query.email,
        hideBusinessNameField: (route.query.hideBusinessNameField).toLowerCase() === 'true'
      })
    },
    {
      path: '/patient/estimate/:id',
      name: 'patient-estimate',
      component: PatientEstimate,
      props: true
    },
    {
      path: '/patient/:id',
      name: 'patient-detail',
      component: PatientDetail,
      props: true
    },
    {
      path: '/estimates',
      name: 'estimates',
      component: Estimates,
      props: true
    },
    {
      path: '/estimate-templates',
      name: 'estimate-templates',
      component: EstimateTemplates,
      props: true
    },
    {
      path: '/bundles',
      name: 'bundles',
      component: Bundles
    },
    {
      path: '/bundle-candidates',
      name: 'bundle-candidates',
      component: BundleCandidates
    },
    {
      path: '/bundle-payments',
      name: 'bundle-payments',
      component: BundlePaymentDistributions
    },
    {
      path: '/bundle-payments/:id',
      name: 'bundle-payment',
      component: BundlePaymentDistribution,
      props: true
    },
    {
      path: '/payee-dashboard',
      name: 'payee-dashboard',
      component: PayeeDashboard
    },
    {
      path: '/payee-dashboard/:id',
      name: 'payee-dashboard-id',
      component: PayeeDashboard,
      props: true
    },
    {
      path: '/employer-dashboard',
      name: 'employer-dashboard',
      component: EmployerDashboard
    },

    {
      path: '/employer-episode-library',
      name: 'employer-episode-library',
      component: EmployerEpisodeLibrary
    },

    {
      path: '/payees',
      name: 'payees',
      component: Payees
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      props: true
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: Analytics,
      props: true
    },
    {
      path: '/custom-notifications',
      name: 'custom-notifications',
      component: CustomNotifications,
      props: true
    },
    {
      path: '/audit-logs',
      name: 'audit-logs',
      component: AuditLogs,
      props: true
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: (to, from, next) => {
        store.logoutUser()
        next({ path: '/login', replace: true })
      }
    },
    {
      path: '/ub04-claim/:id',
      name: 'ub04-claim',
      props: true,
      component: UB04Claim
    },
    {
      path: '/allowable-fee-schedules',
      name: 'allowable-fee-schedules',
      component: AllowableFeeSchedules
    },
    {
      path: '/allowable-fee-schedules-codes/:id',
      name: 'allowable-fee-schedules-codes',
      props: route => ({ id: Number(route.params.id) }),
      component: AllowableFeeScheduleCodes
    },
    {
      path: '/asc-fee-schedules',
      name: 'asc-fee-schedules',
      component: AscFeeSchedules
    },
    {
      path: '/asc-fee-schedules-codes/:id',
      name: 'asc-fee-schedules-codes',
      component: AscFeeSchedulesCodes,
      props: route => ({ id: Number(route.params.id) })
    },
    {
      path: '/insurance-benefits/estimate/:id',
      name: 'insurance-benefits',
      component: InsuranceBenefits,
      props: route => ({ id: Number(route.params.id), mode: 'estimate' })
    },
    {
      path: '/insurance-benefits/visit/:id',
      name: 'visit-insurance-benefits',
      component: InsuranceBenefits,
      props: route => ({ id: Number(route.params.id), mode: 'visit' })
    },
    {
      path: '/search-patient',
      name: 'search-patient',
      component: SearchPatient
    },
    {
      path: '/estimate-fees',
      name: 'estimate-fees',
      component: EstimateFees
    },
    {
      path: '/estimate-asc-fees',
      name: 'estimate-asc-fees',
      component: EstimateAscFees
    }
  ]
})

router.beforeEach((to, from, next) => {
  const anonymousRoutes = ['login', 'reset-password', 'forgot-password', 'payee-signup']
  if (anonymousRoutes.includes(to.name)) {
    next()
    return
  }
  if (store.isAuthenticated !== true) {
    next({
      name: 'login',
      replace: true,
      params: {
        nextPath: to.fullPath
      }
    })
  } else {
    next()
  }
})

export default router
